import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IGameEnvironment } from '../model/gameEnvironment/GameEnvironment';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useGameEnvironmentResult {
    isLoaded: boolean;
    gameEnvironment: IGameEnvironment | null;
}

export const useGameEnvironment = (gameEnvironmentId?: number) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState(() => ({
        isLoaded: false,
        gameEnvironment: null
    } as useGameEnvironmentResult));

    useEffect(() => {

        setResult({ isLoaded: false, gameEnvironment: null });

        if (gameEnvironmentId) {

            rootStore.gameEnvironmentsStore.getGameEnvironment(gameEnvironmentId)
                .then((gameEnvironment) => {
                    setResult({
                        isLoaded: true,
                        gameEnvironment: gameEnvironment
                    });
                })
                .catch(e => publishNotification({
                    text: `Error loading game environment: ${e.message}`,
                    canClose: true
                }));
        } else {
            const newGameEnvironment = rootStore.gameEnvironmentsStore.addGameEnvironment();
            setResult({ isLoaded: true, gameEnvironment: newGameEnvironment });
        }
    }, [rootStore.gameEnvironmentsStore.gameEnvironments, publishNotification, gameEnvironmentId]);

    return result;
};
